<template>
  <div class="plate-item">
    <div class="plate-item-inner">
       <div class="plate-item-bg">
        <div class="plate-top">
          <i class="plate-item-add"></i>
        </div>
        <div class="plate-mask">
          <span>{{$bus.transify['T_P_CHOOSE_HINT']}}</span>
        </div>
      </div>
    </div>
    <div class="plate-item-active" v-if="$bus.selects.length >= index + 1">
      <div class="plate-item-main">
        <div class="plate-top" :style="{'background-image': 'url('+ item.src + ')'}">
          <div class="plate-item-nums" v-show="item.nums > 1"><span>x</span><span>{{item.nums}}</span></div>
        </div>
      </div>
      <div class="plate-item-active-bg"></div>
      <div class="plate-item-discount" :class="discountsStyle">
        <span>{{PercentText}}</span>
      </div>
      <div class="plate-item-diamond">
        <div class="diamond-item after">
          <i class="diamond"></i>
          <span class="gem-nums">{{getDiscountPrice(item.price)}}</span>
        </div>
        <div class="diamond-item before">
          <i class="diamond"></i>
          <span class="gem-nums">{{item.price}}</span>
        </div>
      </div>
      <div class="plate-mask">
        <span>{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    index: Number
  },
  data () {
    return {
      discountsStyle: '',
      item: Object
    }
  },
  computed: {
    PercentText () {
      let discount = 0
      switch (this.$bus.selects.length) {
        case 1:
          discount = this.$bus.actInfo.discounts[0]
          this.setDiscount('single', discount)
          return discount + '%'
        case 2:
          discount = this.$bus.actInfo.discounts[1]
          this.setDiscount('double', discount)
          return discount + '%'
        case 3:
          discount = this.$bus.actInfo.discounts[2]
          this.setDiscount('triple', discount)
          return discount + '%'
        default:
          return ''
      }
    },
    getDiscountPrice () {
      return price => {
        return Math.floor(Number(price) * (100 - this.$bus.discount) / 100)
      }
    }
  },
  methods: {
    setDiscount (type, per) {
      this.discountsStyle = type
      this.item = this.$bus.selects[this.index]
      this.$bus.discount = Number(per)
    }
  }
}
</script>

<style lang="scss" scoped>
.plate-item {
  position: relative;
  @include px2res(width, 394);
  @include px2res(height, 228);
  @include flexrc;
  .plate-item-inner {
    @include px2res(width, 380);
    @include px2res(height, 200);
    @include px2res(border-width, 5);
    border-style: solid;
    border-color: #21242c;
    .plate-item-bg {
      @include flexrc;
      flex-direction: column;
      justify-content: space-between;
      @include px2res(width, 370);
      @include px2res(height, 188);
      @include px2res(border-width, 4);
      border-style: solid;
      border-color: #12110e;
      background-color: rgba(17, 22, 32, .6);
      position: relative;
      .plate-top {
        @include px2res(width, 360);
        @include px2res(height, 134);
        @include flexrc;
        .plate-item-add {
          @include px2res(width, 68);
          @include px2res(height, 67);
        }
      }
      .plate-mask {
        @include flexrc;
        @include px2res(width, 360);
        @include px2res(height, 46);
        @include px2res(font-size, 22);
        background: rgba(18,24,38, .9);
        color: #8498B4FF;
        text-transform: uppercase;
        line-height: 1;
        text-align: center;
      }
    }
  }
  .plate-item-active {
    @include px2res(width, 394);
    @include px2res(height, 228);
    @include flexrc;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    animation: scale-bounce .3s ease-out both;
    .plate-item-main {
      @include flexrc;
      @include px2res(width, 362);
      @include px2res(height, 192);
      .plate-top {
        width: 80%;
        height: 100%;
        text-align: center;
        position: relative;
        background-size: contain;
        .plate-item-nums {
          position: absolute;
          right: 5%;
          top: 40%;
          z-index: 9;
          color: #FFDE00;
          font-weight: 500;
          @include px2res(font-size, 40);
        }
      }
    }
    .plate-item-active-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      background-size: 100% 100%;
      top: 0;
      left: 0;
    }
    .plate-item-discount {
      position: absolute;
      z-index: 2;
      font-weight: 500;
      color: #fff;
      @include px2res(width, 107);
      @include px2res(height, 113);
      @include px2res(right, 6);
      @include px2res(top, 3);
      @include px2res(font-size, 32);
      span {
        position: absolute;
        font-weight: inherit;
        line-height: 1;
        transform: rotate(44deg);
        transform-origin: bottom right;
        @include px2res(right, 32);
        @include px2res(top, 42);
      }
    }
    .plate-item-diamond {
      position: absolute;
      z-index: 2;
      font-weight: 500;
      @include px2res(top, 31);
      @include px2res(left, 33);
      @include px2res(font-size, 28);
      .diamond-item {
        @include flexrc;
        justify-content: flex-start;
        position: relative;
        line-height: 1;
        @include px2res(margin-bottom, 5);
        .diamond {
          @include px2res(width, 30);
          @include px2res(height, 26);
          @include px2res(margin-right, 8);
        }
      }
      .diamond-item.after {
        color: #FFDE00;
      }
      .diamond-item.before::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 106%;
        height: 1px;
        background: #FF0000;
      }
    }
    .plate-mask {
      position: absolute;
      z-index: 2;
      color: #fff;
      line-height: 1;
      width: 86%;
      left: 7%;
      overflow: hidden;
      text-align: center;
      @include flexrc;
      @include px2res(height, 46);
      @include px2res(bottom, 18);
      @include px2res(font-size, 22);
    }
  }
}
@keyframes scale-bounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/plate/item.vue